import LocalizedStrings from 'react-localization';

let strings = new LocalizedStrings({
    pl: {
        // HEADER
        wyszukiwarka: "Wyszukiwarka połączeń",
        aktualnosci: "Aktualności",
        uslugi: "Usługi",
        bilety: "Bilety",
        mojeKonto: "Moje konto",
        koszyk: "Koszyk",
        wynajem: "Wynajem",
        zamowMiesieczny: "Bilety miesięczne",
        mojeBilety: "Moje bilety",
        daneKlienta: "Dane klienta",
        zmianaHasla: "Zmiana hasła",
        wyloguj: "Wyloguj",

        // SLIDER
        przykladowyTekst: "Przykładowy tekst do zakładki",

        // WYSZUKIWARKA
        miejsceWyjazdu: "Miejsce wyjazdu",
        miejsceDocelowe: "Miejsce docelowe",
        godzinaWyjazdu: "Godzina",
        dataWyjazdu: "Data",
        przystanekWyjazdu: "Przystanek początkowy",
        przystanekKoncowy: "Przystanek końcowy",
        szukaj: "Szukaj",
        dataPowrotu: "Data powrotu",
        wybierzMiejsce: "Wybierz miejsce",
        dodajDatePowrotu: " Dodaj datę powrotu",

        // WYNIKI WYSZUKIWANIA
        wynikiWyszukiwaniaPolaczen: "Wyniki wyszukiwania połączeń",
        wyjazd: "Wyjazd",
        powrot: "Powrót",
        trasa: "Trasa",
        miejsca: "Miejsca",
        cena: "Cena",
        normalny: "(normalny)",
        wybierz: "Wybierz",
        brakPolaczen: "Brak połączeń",
        trwaWyszukiwaniePolaczen: "Trwa wyszukiwanie połączeń",

        // KOSZYK
        koszykPusty: "Koszyk jest pusty",
        przejdzDoKoszyka: "Przejdź do koszyka",
        podsumowanie: "Podsumowanie",
        zakup: "Zakup",
        rezerwacja: "Rezerwacja",

        // AKTUALNOŚCI
        czytajWiecej: 'Czytaj więcej...',
        zwin: 'Zwiń',
        wiecejAktualnosci: 'Więcej aktualności',

        // O NAS - STRONA GŁÓWNA
        czysteWnetrze: 'Czyste wnętrze',
        zawszeNaCzas: 'Zawsze na czas',
        szybkieWifi: 'Szybkie WiFi',
        kulturalniKierowcy: 'Kulturalni kierowcy',

        // APLIKACJA MOBILNA
        biletyPodReka: "Twoje bilety zawsze pod ręką",

        // MAPA POŁĄCZEŃ
        mapaPolaczen: "Mapa połączeń Marcel Bus",
        mapaPolaczenTresc: "Jesteśmy największą firmą przewozową w regionie posiadającą we flocie ponad 100 pojazdów. Obecnie obsługujemy 9 linii regularnych." +
            " Wykonujemy codziennie około 400 kursów dowożąc tysiące osób do miejsc pracy, szkół i uczelni.",

        // STOPKA
        obslugaKlienta: "Obsługa klienta",
        vouchery: "Vouchery",
        aplikacje: "Aplikacje",
        prawaPasazerow: "Prawa pasażerów",
        anulowanie: "Anulowanie i zmiana biletu",
        kontakt: "Kontakt",
    },
    en: {
        // HEADER
        wyszukiwarka: "Wyszukiwarka połączeń",
        aktualnosci: "Aktualności",
        uslugi: "Usługi",
        bilety: "Bilety",
        mojeKonto: "Moje konto",
        koszyk: "Koszyk",
        wynajem: "Wynajem",
        zamowMiesieczny: "Bilety miesięczne",
        mojeBilety: "Moje bilety",
        daneKlienta: "Dane klienta",
        zmianaHasla: "Zmiana hasła",
        wyloguj: "Wyloguj",

        // SLIDER
        przykladowyTekst: "Przykładowy tekst do zakładki",

        // WYSZUKIWARKA
        miejsceWyjazdu: "Miejsce wyjazdu",
        miejsceDocelowe: "Miejsce docelowe",
        godzinaWyjazdu: "Godzina",
        dataWyjazdu: "Data",
        przystanekWyjazdu: "Przystanek początkowy",
        przystanekKoncowy: "Przystanek końcowy",
        szukaj: "Szukaj",
        dataPowrotu: "Data powrotu",
        wybierzMiejsce: "Wybierz miejsce",
        dodajDatePowrotu: " Dodaj datę powrotu",

        // WYNIKI WYSZUKIWANIA
        wynikiWyszukiwaniaPolaczen: "Wyniki wyszukiwania połączeń",
        wyjazd: "Wyjazd",
        powrot: "Powrót",
        trasa: "Trasa",
        miejsca: "Miejsca",
        cena: "Cena",
        normalny: "(normalny)",
        wybierz: "Wybierz",
        brakPolaczen: "Brak połączeń",
        trwaWyszukiwaniePolaczen: "Trwa wyszukiwanie połączeń",

        // KOSZYK
        koszykPusty: "Koszyk jest pusty",
        przejdzDoKoszyka: "Przejdź do koszyka",
        podsumowanie: "Podsumowanie",
        zakup: "Zakup",
        rezerwacja: "Rezerwacja",

        // AKTUALNOŚCI
        czytajWiecej: 'Czytaj więcej...',
        zwin: 'Zwiń',
        wiecejAktualnosci: 'Więcej aktualności',

        // O NAS - STRONA GŁÓWNA
        czysteWnetrze: 'Czyste wnętrze',
        zawszeNaCzas: 'Zawsze na czas',
        szybkieWifi: 'Szybkie WiFi',
        kulturalniKierowcy: 'Kulturalni kierowcy',

        // APLIKACJA MOBILNA
        biletyPodReka: "Twoje bilety zawsze pod ręką",

        // MAPA POŁĄCZEŃ
        mapaPolaczen: "Mapa połączeń Marcel Bus",
        mapaPolaczenTresc: "Jesteśmy największą firmą przewozową w regionie posiadającą we flocie ponad 100 pojazdów. Obecnie obsługujemy 9 linii regularnych." +
            " Wykonujemy codziennie około 400 kursów dowożąc tysiące osób do miejsc pracy, szkół i uczelni.",

        // STOPKA
        obslugaKlienta: "Obsługa klienta",
        vouchery: "Vouchery",
        aplikacje: "Aplikacje",
        prawaPasazerow: "Prawa pasażerów",
        anulowanie: "Anulowanie i zmiana biletu",
        kontakt: "Kontakt",
    },
    // en: {
    //     // HEADER
    //     wyszukiwarka: "Search for connections",
    //     aktualnosci: "News",
    //     uslugi: "Services",
    //     bilety: "Tickets",
    //     mojeKonto: "My account",
    //     koszyk: "Cart ",
    //     wynajem: "Rent",
    //     zamowMiesieczny: "Monthly tickets",
    //     mojeBilety: "My tickets",
    //     daneKlienta: "Customer data",
    //     zmianaHasla: "Password change",
    //     wyloguj: "Logout",
    //
    //     // SLIDER
    //     przykladowyTekst: "Sample slider text for",
    //
    //     // WYSZUKIWARKA
    //     miejsceWyjazdu: "From",
    //     miejsceDocelowe: "To",
    //     godzinaWyjazdu: "Time",
    //     dataWyjazdu: "Date",
    //     przystanekWyjazdu: "Departure",
    //     przystanekKoncowy: "Target",
    //     szukaj: "Search",
    //     dataPowrotu: "Date of return",
    //     wybierzMiejsce: "Choose place",
    //     dodajDatePowrotu: " Add date of return",
    //
    //     // WYNIKI
    //     wynikiWyszukiwaniaPolaczen: "List of connections",
    //     wyjazd: "Departure",
    //     powrot: "Return",
    //     trasa: "Route",
    //     miejsca: "Places",
    //     cena: "Price",
    //     normalny: "(normal)",
    //     wybierz: "Choose",
    //     brakPolaczen: "No connections",
    //     trwaWyszukiwaniePolaczen: "Searching for connections",
    //
    //     // KOSZYK
    //     koszykPusty: "Cart is empty",
    //     przejdzDoKoszyka: "Go to cart",
    //     podsumowanie: "Total",
    //     zakup: "Buy",
    //     rezerwacja: "Reserve",
    //
    //     // AKTUALNOSCI
    //     czytajWiecej: 'Read more...',
    //     zwin: 'Hide',
    //     wiecejAktualnosci: 'More news',
    //
    //     // O NAS - STRONA GŁÓWNA
    //     czysteWnetrze: 'Clean interior',
    //     zawszeNaCzas: 'Always on time',
    //     szybkieWifi: 'Quick WiFi',
    //     kulturalniKierowcy: 'Polite drivers',
    //
    //     // APLIKACJA MOBILNA
    //     biletyPodReka: "Your tickets always with you",
    //
    //     // MAPA POŁĄCZEŃ
    //     mapaPolaczen: "Map of connections Marcel Bus",
    //     mapaPolaczenTresc: "We are the biggest transport company in region, having in our fleet over 100 vehicles. Currently we operate 9 regular lines." +
    //         " We make about 400 courses every day, helping thousands of people get to work or school.",
    //
    //     // STOPKA
    //     obslugaKlienta: "Customer service",
    //     vouchery: "Voucher",
    //     aplikacje: "Apps",
    //     prawaPasazerow: "Passenger rights",
    //     anulowanie: "Cancelling or changing ticket",
    //     kontakt: "Contact",
    // }
});

export default strings;



// WEBPACK FOOTER //
// ./src/components/strings/localeStrings.js